import { rootStore } from "../Store/rootStore";

export default function setLoader(type: string, payload: string) {
	if (type) {
		rootStore.dispatch({ type, payload });
	}
}
